module.exports = __webpack_public_path__ + "files/fc9988e61dd9ef9308d0430543405c02.png";